import DashboardChartCard, { DASHBOARD_CHART_OPTIONS, dashboardActionStyle as buttonStaticStyle } from "./DashboardChartCard";
import * as React from "react";
import ReactDOM from "react-dom";
import {
    Chart,
    ChartSeries,
    ChartSeriesItem,
    ChartCategoryAxis,
    ChartCategoryAxisItem,
    ChartTitle,
    ChartLegend,
    ChartValueAxis,
    ChartValueAxisItem,
    ChartSeriesDefaults,
    exportVisual,
} from "@progress/kendo-react-charts";
import configData from "../../config.json";
import { GetSession, GetToken } from "../../components/Session";
import DashboardCards from "./DashboardCards";
import "hammerjs";
import { exportPDF } from "@progress/kendo-drawing";
import { saveAs } from "@progress/kendo-file-saver";
import { GetCloudLogin } from "../../WeighBridge/Helpers";







const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 10000,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
    },
    content: {
        backgroundColor: "#fff",
        borderRadius: "8px",
        width: "95vw",
        height: "95vh",
        padding: "20px",
        position: "relative",
        display: "flex",
        flexDirection: "column",
    },
    closeBtnTopRight: {
        position: "absolute",
        top: "10px",
        right: "15px",
        fontSize: "28px",
        border: "none",
        background: "none",
        cursor: "pointer",
    },
    closeBtnBottom: {
        marginTop: "auto",
        padding: "10px 25px",
        borderRadius: "5px",
        border: "1px solid #333",
        background: "#fff",
        cursor: "pointer",
    },
};


const WeeklyTrend = ({ siteId = 0 }) => {
    const weekDays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

    const [categories, setCategories] = React.useState(null);
    const [weeklySales, setWeeklySales] = React.useState(null);
    const [productPerformance, setProductPerformance] = React.useState(null);
    const [accumulated, setAccumulated] = React.useState(null);
    const [pieData, setPieData] = React.useState(null);
    const [siteHeading, setSiteHeading] = React.useState("Site Performance");
    const [modalChart, setModalChart] = React.useState(null);

    const [title, setTitle] = React.useState("");
    const [salesYAxis, setSalesYAxis] = React.useState("");
    const [productYAxis, setProductYAxis] = React.useState("");
    const [accYAxis, setAccYAxis] = React.useState("");
    const [isLoading, setIsLoading] = React.useState(true);

    const sale = React.useRef(null);
    const product = React.useRef(null);
    const total = React.useRef(null);
    const site = React.useRef(null);


    const onImageExportClick = (e) => {
        const chart = e.currentTarget.name;
        let visual = null;

        if (chart === "sales") visual = sale.current && exportVisual(sale.current);
        else if (chart === "product") visual = product.current && exportVisual(product.current);
        else if (chart === "total") visual = total.current && exportVisual(total.current);
        else visual = site.current && exportVisual(site.current);

        if (visual) {
            exportPDF(visual, { paperSize: "A4", landscape: true }).then((uri) =>
                saveAs(uri, "Weekly Performance.pdf")
            );
        }
    };


    React.useEffect(() => {
        setIsLoading(true);
        GetCloudLogin((cred) => {
            let token = cred === "" ? cred : cred.token;
            let sess = GetSession();
            let baseUrl =
                token !== undefined && token !== ""
                    ? sess.CloudURL
                    : configData.SERVER_URL;

            const offset = new Date().getTimezoneOffset() / 60;
            baseUrl += `apiV7/dashboard/getweeklytrends?offset=${offset}&siteId=${siteId}`;

            fetch(baseUrl, {
                method: "GET",
                headers: {
                    Authorization:
                        "Bearer " + (token === null || token === "" ? GetToken() : token),
                },
            })
                .then((r) => r.json())
                .then((d) => {
                    setWeeklySales(d.weeklySales);
                    setProductPerformance(d.productPerformance);
                    setAccumulated(d.accumulated);
                    setPieData(d.pieData);
                    setCategories(d.productNames);
                    setTitle(d.title);
                    setSalesYAxis(d.salesY);
                    setProductYAxis(d.productY);
                    setAccYAxis(d.accY);
                    if (d.sites === 1) setSiteHeading("Product Share");
                                    setIsLoading(false);
                })
                .catch(() => setIsLoading(false));
        });
    }, []);


    const ExportZoomButtons = ({ name }) => (
        <div style={{ display: "flex", gap: "8px", justifyContent: "flex-end", marginBottom: 8 }}>
            <button
                name={name}
                onClick={onImageExportClick}
                style={buttonStaticStyle}
                className="k-button k-button-icon"
            >
                <i className="fa fa-download" />
            </button>
            <button
                onClick={() => setModalChart(name)}
                style={buttonStaticStyle}
                className="k-button k-button-icon"
            >
                <i className="fa fa-expand" />
            </button>
        </div>
    );


    const renderModalChart = () => {
        const common = { height: "85vh", width: "100%" };

        if (modalChart === "sales")
            return (
                <Chart {...DASHBOARD_CHART_OPTIONS} ref={sale} style={common}>
                    <ChartTitle text={title} font="22Pt bold" />
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem categories={weekDays || []} />
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                        <ChartValueAxisItem title={{ text: salesYAxis }} />
                    </ChartValueAxis>
                    <ChartSeriesDefaults type="line" />
                    <ChartSeries>
                        {(weeklySales || []).map((i, idx) => (
                            <ChartSeriesItem key={idx} data={i.data} name={i.name} />
                        ))}
                    </ChartSeries>
                </Chart>
            );

        if (modalChart === "product")
            return (
                <Chart {...DASHBOARD_CHART_OPTIONS} ref={product} style={common}>
                    <ChartTitle text="Product Performance (Top 5)" font="22Pt bold" />
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem categories={categories || []} />
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                        <ChartValueAxisItem title={{ text: productYAxis }} />
                    </ChartValueAxis>
                    <ChartSeriesDefaults type="column" overlay={{ gradient: "sharpBevel" }} />
                    <ChartSeries>
                        {(productPerformance || []).map((i, idx) => (
                            <ChartSeriesItem key={idx} data={i.data} name={i.name} />
                        ))}
                    </ChartSeries>
                </Chart>
            );

        if (modalChart === "total")
            return (
                <Chart {...DASHBOARD_CHART_OPTIONS} ref={total} style={common}>
                    <ChartTitle text="Accumulated Total" font="22Pt bold" />
                    <ChartCategoryAxis>
                        <ChartCategoryAxisItem categories={weekDays || []} />
                    </ChartCategoryAxis>
                    <ChartValueAxis>
                        <ChartValueAxisItem title={{ text: accYAxis }} />
                    </ChartValueAxis>
                    <ChartSeriesDefaults type="area" overlay={{ gradient: "sharpBevel" }} />
                    <ChartSeries>
                        {(accumulated || []).map((i, idx) => (
                            <ChartSeriesItem key={idx} data={i.data} name={i.name} />
                        ))}
                    </ChartSeries>
                </Chart>
            );

        return (
            <Chart {...DASHBOARD_CHART_OPTIONS} ref={site} style={common}>
                <ChartTitle text={siteHeading} font="22Pt bold" />
                <ChartSeries>
                    <ChartSeriesItem
                        type="pie"
                        overlay={{ gradient: "sharpBevel" }}
                        data={pieData || []}
                        categoryField="name"
                        field="share"
                    />
                </ChartSeries>
            </Chart>
        );
    };


    return (
        <>
            <DashboardCards siteId={siteId} period="weekly" />

            <div className="row">
                {(isLoading || weeklySales) && (
                    <div className="col-6 mb-4">

                        <DashboardChartCard loading={isLoading} title={title} icon="fa-chart-line" subtitle="Sales comparison over time" actions={<ExportZoomButtons name="sales" />}>
                            <Chart {...DASHBOARD_CHART_OPTIONS} ref={sale} style={{ height: 245 }}>

                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem categories={weekDays || []} />
                                </ChartCategoryAxis>
                                <ChartValueAxis>
                                    <ChartValueAxisItem title={{ text: salesYAxis }} />
                                </ChartValueAxis>
                                <ChartSeries>
                                    {(weeklySales || []).map((i, idx) => (
                                        <ChartSeriesItem key={idx} type="line" data={i.data} name={i.name} />
                                    ))}
                                </ChartSeries>
                            </Chart>
                        </DashboardChartCard>
                    </div>
                )}

                {(isLoading || productPerformance) && (
                    <div className="col-6 mb-4">

                        <DashboardChartCard loading={isLoading} title="Product Performance (Top 5)" icon="fa-cube" subtitle="Compare performance across products" actions={<ExportZoomButtons name="product" />}>
                            <Chart {...DASHBOARD_CHART_OPTIONS} ref={product} style={{ height: 245 }}>

                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem categories={categories || []} />
                                </ChartCategoryAxis>
                                <ChartValueAxis>
                                    <ChartValueAxisItem title={{ text: productYAxis }} />
                                </ChartValueAxis>
                                <ChartSeriesDefaults type="column" overlay={{ gradient: "sharpBevel" }} />
                                <ChartSeries>
                                    {(productPerformance || []).map((i, idx) => (
                                        <ChartSeriesItem key={idx} data={i.data} name={i.name} />
                                    ))}
                                </ChartSeries>
                            </Chart>
                        </DashboardChartCard>
                    </div>
                )}
            </div>

            <div className="row">
                {(isLoading || accumulated) && (
                    <div className="col-6 mb-4">

                        <DashboardChartCard loading={isLoading} title="Accumulated Total" icon="fa-arrow-trend-up" subtitle="Cumulative performance comparison" actions={<ExportZoomButtons name="total" />}>
                            <Chart {...DASHBOARD_CHART_OPTIONS} ref={total} style={{ height: 245 }}>

                                <ChartCategoryAxis>
                                    <ChartCategoryAxisItem categories={weekDays || []} />
                                </ChartCategoryAxis>
                                <ChartValueAxis>
                                    <ChartValueAxisItem title={{ text: accYAxis }} />
                                </ChartValueAxis>
                                <ChartSeriesDefaults type="area" overlay={{ gradient: "sharpBevel" }} />
                                <ChartSeries>
                                    {(accumulated || []).map((i, idx) => (
                                        <ChartSeriesItem key={idx} data={i.data} name={i.name} />
                                    ))}
                                </ChartSeries>
                            </Chart>
                        </DashboardChartCard>
                    </div>
                )}

                {(isLoading || pieData) && (
                    <div className="col-6 mb-4">

                        <DashboardChartCard loading={isLoading} title={siteHeading} icon="fa-location-dot" subtitle="Performance breakdown" actions={<ExportZoomButtons name="site" />}>
                            <Chart {...DASHBOARD_CHART_OPTIONS} ref={site} style={{ height: 245 }}>

                                <ChartSeries>
                                    <ChartSeriesItem
                                        type="pie"
                                        overlay={{ gradient: "sharpBevel" }}
                                        data={pieData || []}
                                        categoryField="name"
                                        field="share"
                                    />
                                </ChartSeries>
                            </Chart>
                        </DashboardChartCard>
                    </div>
                )}
            </div>

            {modalChart &&
                ReactDOM.createPortal(
                    <div
                        style={modalStyles.overlay}
                        onClick={() => setModalChart(null)}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div
                            style={modalStyles.content}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button
                                style={modalStyles.closeBtnTopRight}
                                onClick={() => setModalChart(null)}
                                aria-label="Close"
                            >
                                �
                            </button>
                            {renderModalChart()}
                            <button
                                style={modalStyles.closeBtnBottom}
                                onClick={() => setModalChart(null)}
                            >
                                Close
                            </button>
                        </div>
                    </div>,
                    document.body
                )}
        </>
    );
};

export default WeeklyTrend;
